/**
 * SnippetOverlay Component
 * Shows countdown timer during snippet playback
 */

import React from 'react';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';

const SnippetOverlay = ({ timeLeft, totalTime, trackTitle, artistName, navHeight = 0 }) => {
  const progress = ((totalTime - timeLeft) / totalTime) * 100;
  
  return (
    <motion.div
      initial={{ opacity: 0, x: 20 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 20 }}
      className="fixed right-3 z-40"
      style={{ top: navHeight ? navHeight + 56 : 128 }}
      data-testid="snippet-overlay"
    >
      <div className="bg-[#12101A]/95 backdrop-blur-xl rounded-2xl border border-white/10 px-4 py-3 shadow-xl">
        <div className="flex items-center gap-3">
          {/* Timer Icon */}
          <div className="relative w-10 h-10">
            <svg className="w-10 h-10 -rotate-90">
              <circle
                cx="20"
                cy="20"
                r="18"
                fill="none"
                stroke="rgba(255,255,255,0.1)"
                strokeWidth="3"
              />
              <circle
                cx="20"
                cy="20"
                r="18"
                fill="none"
                stroke="#00F0FF"
                strokeWidth="3"
                strokeLinecap="round"
                strokeDasharray={`${progress * 1.13} 113`}
                className="transition-all duration-1000"
              />
            </svg>
            <span className="absolute inset-0 flex items-center justify-center text-white text-sm font-bold">
              {timeLeft}
            </span>
          </div>

          {/* Info */}
          <div>
            <p className="text-white text-sm font-medium">Preview Mode</p>
            <p className="text-[#A1A1AA] text-xs">
              Sign up to unlock full track
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SnippetOverlay;
